import { render, staticRenderFns } from "./UserPaymentsMethods.vue?vue&type=template&id=5ee87e90&scoped=true&"
import script from "./UserPaymentsMethods.vue?vue&type=script&lang=js&"
export * from "./UserPaymentsMethods.vue?vue&type=script&lang=js&"
import style0 from "./UserPaymentsMethods.vue?vue&type=style&index=0&id=5ee87e90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee87e90",
  null
  
)

export default component.exports